import OrgsSearch from './OrgsSearch'
export default OrgsSearch
